"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _on = _interopRequireDefault(require("./on"));

exports.on = _on.default;

var _off = _interopRequireDefault(require("./off"));

exports.off = _off.default;

var _filter = _interopRequireDefault(require("./filter"));

exports.filter = _filter.default;

var _listen = _interopRequireDefault(require("./listen"));

exports.listen = _listen.default;
var _default = {
  on: _on.default,
  off: _off.default,
  filter: _filter.default,
  listen: _listen.default
};
exports.default = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dom-helpers/events/index.js
 ** module id = 777
 ** module chunks = 9
 **/